import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { translate, Interpolate } from 'react-i18next'

/* Widgets */
import { Icon, ICON } from 'widget/icon'

/* Styles */
import './index.css'

class Imprint extends Component {

  getItemClass() {
    var className = "imprint component"
    return className
  }

  render() {
    const { t } = this.props
    return (
      <div
          className={ this.getItemClass() }
      >
        <div className="row">
          <div className="column main">
            <div className="column-list">
              <div className="header">
                <h2>{ t("imprint:headline") }</h2>
              </div>
              <div className="body">
                  <Interpolate
                    i18nKey="imprint:content"
                    useDangerouslySetInnerHTML={ true }
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Imprint.propTypes = {}

const mapStateToProps = (state) => {
  return {}
}

const reduxComponent = connect(mapStateToProps)(Imprint)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/imprint/index.jsx